/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_NeverInputs */

const en_share_never = /** @type {(inputs: Share_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No limit`)
};

const de_share_never = /** @type {(inputs: Share_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzt`)
};

/**
* | output |
* | --- |
* | "No limit" |
*
* @param {Share_NeverInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const share_never = /** @type {((inputs?: Share_NeverInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_NeverInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_share_never(inputs)
	return en_share_never(inputs)
});